import { differenceInSeconds } from 'date-fns'
import { useCallback, useEffect, useState } from 'react'

import { getNextLearningDayStart } from '../utils/dailyLearningTime'

/**
 * 새벽 2시(=오늘의학습 마감)까지 남은 시간을 HH:mm:ss 형식으로 반환하는 hook.
 * 매 초마다 자동 업데이트. `enabled=false` 일 때는 setInterval 미동작.
 */
export const useDailyWorksheetRemainingTime = (enabled = true) => {
  const [remainingTime, setRemainingTime] = useState<Date>(new Date())

  const updateRemainingTime = useCallback(() => {
    const now = new Date()
    const targetTime = getNextLearningDayStart(now)

    const totalSeconds = Math.max(0, differenceInSeconds(targetTime, now))

    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    const time = new Date(0, 0, 0, hours, minutes, seconds)
    setRemainingTime(time)
  }, [])

  useEffect(() => {
    if (!enabled) return

    updateRemainingTime()

    const interval = setInterval(updateRemainingTime, 1000)

    return () => clearInterval(interval)
  }, [enabled, updateRemainingTime])

  return remainingTime
}
